import Script from 'next/script'
import { PropsWithChildren } from 'react'
import { GOOGLE_TAG_MANAGER_ID } from '../../../utils/consts'
import { CrispWeb } from '../../CrispWeb'

export default function WebLayout(props: PropsWithChildren) {
  return (
    <>
      {process.env.NODE_ENV === 'production' && (
        <Script id="google-tag-manager" strategy="afterInteractive">
          {`
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','${GOOGLE_TAG_MANAGER_ID}');
            `}
        </Script>
      )}
      {/* <WebChatBot /> */}
      <CrispWeb />
      <div id="myb-gp" className="bg-white px-5 text-webText flex flex-col">
        {props.children}
      </div>
    </>
  )
}
